package com.mgacreative.hotelru.shared.ui.designsystem.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import org.jetbrains.compose.resources.stringResource
import hotelos.shared.ui.designsystem.generated.resources.Res
import hotelos.shared.ui.designsystem.generated.resources.*
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp

data class NavigationMenuItem(
    val title: String,
    val iconName: String = "",
    val imageVector: androidx.compose.ui.graphics.vector.ImageVector? = null,
    val isDestructive: Boolean = false,
    val onClick: () -> Unit
)

@Composable
fun HFNavigationDrawer(
    userName: String = "",
    userEmail: String = "",
    userRole: String = "",
    userRoles: List<String> = emptyList(),
    headerIcon: (@Composable () -> Unit)? = null,
    onLogoutClick: () -> Unit,
    onNavigate: (String) -> Unit = {},
    modifier: Modifier = Modifier
) {
    val normalizedRole = userRole.uppercase().replace("_", " ").replace("-", " ").trim()
    val isSuperAdmin = userEmail.trim().equals("gkhnazat@gmail.com", ignoreCase = true) ||
                      userName.trim().equals("gkhnazat@gmail.com", ignoreCase = true) ||
                      userName.contains("gkhnazat", ignoreCase = true) ||
                      normalizedRole == "SUPER ADMIN" ||
                      userRoles.any { it.equals("SUPER_ADMIN", ignoreCase = true) }

    val isHotelAdmin = isSuperAdmin || 
                      normalizedRole == "ADMIN" || 
                      userRoles.any { it.equals("ADMIN", ignoreCase = true) }

    val isHotelStaffOrOwner = isHotelAdmin || 
                              normalizedRole == "HOTEL OWNER" || 
                              normalizedRole == "OWNER" || 
                              normalizedRole == "MANAGER" ||
                              userRoles.any { 
                                  it.equals("HOTEL_OWNER", ignoreCase = true) || 
                                  it.equals("MANAGER", ignoreCase = true) 
                              }

    fun hasRole(role: String): Boolean {
        if (isSuperAdmin || isHotelAdmin || isHotelStaffOrOwner) return true
        if (normalizedRole.equals(role, ignoreCase = true)) return true
        if (role.equals("FRONT_DESK", ignoreCase = true) && normalizedRole.equals("RECEPTION", ignoreCase = true)) return true
        
        return userRoles.any { it.equals(role, ignoreCase = true) }
    }

    val menuItems = mutableListOf<NavigationMenuItem>().apply {
        add(NavigationMenuItem(com.mgacreative.hotelru.shared.ui.designsystem.i18n.l10n("Gösterge Paneli")) { onNavigate("DashboardScreen") })

        if (hasRole("FRONT_DESK") || hasRole("MANAGER") || isHotelStaffOrOwner) {
            add(NavigationMenuItem(com.mgacreative.hotelru.shared.ui.designsystem.i18n.l10n("Ön Büro (Rezervasyon)")) { onNavigate("NewReservationCalendarScreen") })
            add(NavigationMenuItem(com.mgacreative.hotelru.shared.ui.designsystem.i18n.l10n("Oda Durumları")) { onNavigate("RoomStatusScreen") })
        }
        if (hasRole("HOUSEKEEPING") || hasRole("MANAGER") || isHotelStaffOrOwner) {
            add(NavigationMenuItem(com.mgacreative.hotelru.shared.ui.designsystem.i18n.l10n("Kat Hizmetleri")) { onNavigate("HousekeepingScreen") })
        }
        if (hasRole("ACCOUNTING") || hasRole("MANAGER") || isHotelStaffOrOwner) {
            add(NavigationMenuItem(com.mgacreative.hotelru.shared.ui.designsystem.i18n.l10n("Kasa & Finans")) { onNavigate("CashRegisterScreen") })
        }
        if (hasRole("RESTAURANT") || hasRole("MANAGER") || isHotelStaffOrOwner) {
            add(NavigationMenuItem(com.mgacreative.hotelru.shared.ui.designsystem.i18n.l10n("Restoran POS")) { onNavigate("RestaurantPosScreen") })
        }
        if (hasRole("MANAGER") || hasRole("HOTEL_OWNER") || isHotelStaffOrOwner) {
            add(NavigationMenuItem(com.mgacreative.hotelru.shared.ui.designsystem.i18n.l10n("Personel Yönetimi")) { onNavigate("ShiftPlannerScreen") })
            add(NavigationMenuItem(com.mgacreative.hotelru.shared.ui.designsystem.i18n.l10n("Envanter")) { onNavigate("InventoryScreen") })
        }

        // 🔒 SADECE VE SADECE gkhnazat@gmail.com (Super Admin) GÖREBİLİR
        if (isSuperAdmin) {
            add(NavigationMenuItem(com.mgacreative.hotelru.shared.ui.designsystem.i18n.l10n("Sistem Yönetimi")) { onNavigate("AdminDashboardScreen") })
            add(NavigationMenuItem(com.mgacreative.hotelru.shared.ui.designsystem.i18n.l10n("Üye Yönetimi")) { onNavigate("AdminMembersScreen") })
        }
    }

    Column(
        modifier = modifier
            .fillMaxHeight()
            .width(260.dp)
            .background(Color.White)
    ) {
        // Corporate Brand Header
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 20.dp, vertical = 20.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(
                text = "HotelOS",
                fontSize = 20.sp,
                fontWeight = FontWeight.Bold,
                color = Color(0xFF0F172A),
                letterSpacing = (-0.5).sp
            )
        }
        HorizontalDivider(color = Color(0xFFF1F5F9), modifier = Modifier.padding(horizontal = 16.dp))

        // Main Navigation List (Text only, corporate SaaS layout)
        LazyColumn(
            modifier = Modifier
                .weight(1f)
                .padding(vertical = 8.dp)
        ) {
            items(menuItems) { item ->
                DrawerMenuItem(
                    item = item,
                    textColor = Color(0xFF334155),
                    fontWeight = FontWeight.Medium
                )
            }
        }

        // Bottom Footer (Secondary Actions, Language & Logout)
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(bottom = 16.dp)
        ) {
            HorizontalDivider(
                modifier = Modifier.padding(horizontal = 16.dp, vertical = 6.dp),
                color = Color(0xFFE2E8F0)
            )

            // Dynamic Language Selector Row
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = 20.dp, vertical = 4.dp),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Text(
                    text = com.mgacreative.hotelru.shared.ui.designsystem.i18n.l10n("Dil / Language"),
                    fontSize = 13.sp,
                    color = Color(0xFF64748B),
                    fontWeight = FontWeight.Medium
                )
                LanguageSelectorDropdown()
            }

            DrawerMenuItem(
                item = NavigationMenuItem(com.mgacreative.hotelru.shared.ui.designsystem.i18n.l10n("Yardım & Destek")) { onNavigate("HelpScreen") },
                textColor = Color(0xFF475569),
                fontWeight = FontWeight.Normal
            )
            DrawerMenuItem(
                item = NavigationMenuItem(
                    title = com.mgacreative.hotelru.shared.ui.designsystem.i18n.l10n("Oturumu Kapat"),
                    isDestructive = true,
                    onClick = onLogoutClick
                ),
                textColor = Color(0xFFDC2626),
                fontWeight = FontWeight.SemiBold
            )
        }
    }
}

@Composable
fun DrawerMenuItem(
    item: NavigationMenuItem,
    textColor: Color = Color(0xFF334155),
    fontWeight: FontWeight = FontWeight.Medium
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 12.dp, vertical = 2.dp)
            .clip(RoundedCornerShape(8.dp))
            .clickable { item.onClick() }
            .padding(horizontal = 14.dp, vertical = 10.dp)
    ) {
        Text(
            text = item.title,
            color = textColor,
            fontWeight = fontWeight,
            fontSize = 14.sp
        )
    }
}

